import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { theme } from '../../../config';
import { sortQueuesByName } from '../../common';
import { LobHeaderRow } from '../common/lobHeaderRow';
import { useControlledExpansion, useSelectQueuesByLobPerScenario } from '../common/selectors';
import { getConstraintExpansionKey, getLobExpansionKey } from '../constants';
import { useSummaryByDisplayMode, useSummaryChunkSize } from '../selectors';
import { ServiceStandardConstraintHeaderRow } from './serviceStandardDetails';
var ServiceStandardLobRow = function (_a) {
  var _b, _c;
  var lob = _a.lob,
    perScenarioLob = _a.perScenarioLob,
    expandedItems = _a.expandedItems,
    onToggleItem = _a.onToggleItem,
    data = _a.data,
    chunkSize = _a.chunkSize,
    serviceRows = _a.serviceRows;
  var t = useTranslation('report', {
    keyPrefix: 'annual'
  }).t;
  var flatPerScenario = React.useMemo(function () {
    return perScenarioLob.flat();
  }, [perScenarioLob]);
  // ServiceStandardQueueRow looks up each scenario's queue by position (queueIdx), not by
  // name, so the template arrays below and every per-scenario array must be sorted with the
  // exact same comparator to keep those positions aligned. (Pre-existing: if a scenario is
  // missing a queue the template has, positions still drift regardless of sort order — see
  // serviceStandardDetails.tsx.)
  var perScenarioDefQueues = flatPerScenario.map(function (scenLob) {
    return sortQueuesByName(scenLob.defQueues);
  });
  var perScenarioNonDefQueues = flatPerScenario.map(function (scenLob) {
    return sortQueuesByName(scenLob.nonDefQueues);
  });
  var displayLobName = lob.lobName === '' ? t('unassignedLob') : lob.lobName;
  var lobExpansionKey = getLobExpansionKey(lob.lobName);
  var _d = useControlledExpansion(expandedItems === null || expandedItems === void 0 ? void 0 : expandedItems[lobExpansionKey], onToggleItem ? function () {
      return onToggleItem(lobExpansionKey);
    } : undefined),
    expanded = _d.expanded,
    handleToggle = _d.handleToggle;
  return _jsxs(_Fragment, {
    children: [_jsx(LobHeaderRow, {
      displayName: displayLobName,
      data: data,
      chunkSize: chunkSize,
      backgroundColor: theme.palette.grey[400],
      expanded: expanded,
      onToggle: handleToggle,
      nestLevel: 1
    }), expanded && _jsxs(_Fragment, {
      children: [_jsx(ServiceStandardConstraintHeaderRow, {
        label: t('deferrable'),
        expansionKey: getConstraintExpansionKey(lob.lobName, 'deferrable'),
        queues: sortQueuesByName(lob.defQueues),
        perScenarioQueues: perScenarioDefQueues,
        data: data,
        chunkSize: chunkSize,
        expandedItems: expandedItems,
        onToggleItem: onToggleItem,
        keys: (_b = serviceRows.defQueue) !== null && _b !== void 0 ? _b : []
      }), _jsx(ServiceStandardConstraintHeaderRow, {
        label: t('nonDeferrable'),
        expansionKey: getConstraintExpansionKey(lob.lobName, 'nonDeferrable'),
        queues: sortQueuesByName(lob.nonDefQueues),
        perScenarioQueues: perScenarioNonDefQueues,
        data: data,
        chunkSize: chunkSize,
        expandedItems: expandedItems,
        onToggleItem: onToggleItem,
        keys: (_c = serviceRows.nonDefQueue) !== null && _c !== void 0 ? _c : []
      })]
    })]
  });
};
export var ServiceStandardSection = function (_a) {
  var expandedItems = _a.expandedItems,
    onToggleItem = _a.onToggleItem,
    headerRows = _a.headerRows;
  var data = useSummaryByDisplayMode();
  var chunkSize = useSummaryChunkSize();
  var lobsPerScenario = useSelectQueuesByLobPerScenario();
  if (!data || !lobsPerScenario.length) return null;
  return _jsx(_Fragment, {
    children: lobsPerScenario.map(function (lobEntry) {
      return _jsx(ServiceStandardLobRow, {
        lob: lobEntry.template,
        perScenarioLob: lobEntry.perScenarioLob,
        data: data,
        chunkSize: chunkSize,
        expandedItems: expandedItems,
        onToggleItem: onToggleItem,
        serviceRows: headerRows
      }, lobEntry.lobName);
    })
  });
};